
<template>
  <div class="main">
    <ul class="list">
      <li :class="type==1&&'message_active'" @click="tabChangeData(1)">全部消息</li>
      <li :class="type==2&&'message_active'" @click="tabChangeData(2)">消息审核</li>
      <li :class="type==3&&'message_active'" @click="tabChangeData(3)">管理员通知</li>
    </ul>
    <div class="line"></div>
    <ul class="dataList">
        <li v-for="(item,index) in shenHeData" :key="index">
          <div v-if="item.type==1||(item.type==3)">
            <img src='imgs/xueyezixun/consultant/home/message.png' alt=""/>
            <ul class="content">
              <li>
                <span>{{item.consultantAdminName}}</span>
                <span>{{item.updatedAt}}</span>
              </li>
              <li>
                <span :style='{fontWeight: "bold",textDecoration:"underline",cursor:"pointer"}'>{{item.studentName}}-{{item.sexName}}-{{item.studentSchool}}</span>
                <span :style='{color:"#F6A724"}'>{{item.typeName}}</span>
                <span>申请</span>
                <span :style='{color:"#5C5C5C",fontWeight:"bolder",float:"right"}'>{{item.statusName}}</span>
              </li>
              <li :style='{display:item.status==4?"block":"none"}'>驳回原因：{{item.remark}}</li>
            </ul>
          </div>
          <div v-else>
            <img src='imgs/xueyezixun/consultant/home/message.png' alt=""/>
            <ul class="content">
              <li>
                <span>{{item.consultantAdminName}}</span>
                <span>{{item.updatedAt}}</span>
              </li>
              <li>
                <span>{{item.content}}</span>
                <span :style="{color:'#3d90f6',cursor:'pointer',display:item.type==2?'inline':'none'}"  @click="$router.push('/consultant/minestudent')" >>>前往学生管理查看</span>
                <span :style="{color:'#3d90f6',cursor:'pointer',display:item.type==2?'none':'inline'}"  @click="$router.push('/consultant/minestudent')" >>>前往学生管理查看</span>
              </li>
            </ul>
          </div>
        </li>
    </ul>
    <Pages :page-data="pageData" :change="getData"></Pages>
    <div style="margin-top:50px" v-if="shenHeData.length==0">
      <NoCotent></NoCotent>
    </div>
  </div>
</template>
<script>
import Pages from '@/components/assembly/Pagination';
import NoCotent from '@/components/NoContent3';
export default {
  name: "message",
  data(){
    return{
      type:1,
      shenHeData:[],
      pageData:{
        cureent:1,
        total:0,
        pageSizee:5,
      }
    }
  },
  components:{ Pages ,NoCotent },
  methods:{
    getData(pageNumber,pageSize){
      const type = this.type
      this.$ajax.post(this.G_acapi+ this.ports.consultant.message.getNoticeList, {
        pageNumber:pageNumber,
        pageSize:pageSize,
        type:type==2&&1||type==3&&2||type==1&&''
      }, {
        headers: {
          token: window.sessionStorage.getItem('ymtxToken')
        }
      }).then((res) => {
        if (res.data.code == 2000) {
          let list = res.data.data.list;
          this.shenHeData=list;
          this.$set(this.pageData, "total", res.data.data.page.count)
        }
      })
    },
    tabChangeData(type){
      this.type=type;
      this.pageData={
        cureent:1,
        total:0,
        pageSize:5,
      }
      this.getData(1,this.pageData.pageSize)
    }
  },
  mounted() {
     this.getData(this.pageData.cureent,this.pageData.pageSize)
  }
}
</script>

<style  lang="less" scoped>
*{
  box-sizing: border-box;
}
.main{
  width: 1200px;
  background: #fff;
  overflow: hidden;
  margin: 30px auto;
  padding: 30px 40px;
  min-height: 700px;
  .list{
    width: 368px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 0;
    li{
      height: 40px;
      font-size: 18px;
      font-weight: 500;
      color: #ABABAB;
      line-height: 25px;
      border-bottom: 2px solid transparent;
      cursor: pointer;
      position: relative;
      z-index: 2;
      //border-bottom: 2px solid #3d90f6;
    }
  }
  .line{
    border-bottom: 1px solid #D9D9D9;
    position: relative;
    top:-1px;
  }
  .message_active{
    border-color:#3d90f6 !important;
    color:#3d90f6 !important;
  }
  .dataList{
    padding-top: 30px;
    &>li{
      width: 100%;
      min-height: 100px;
      background: #FCFCFC;
      border-radius: 2px;
      border: 1px solid #C9C9C9;
      margin-bottom: 20px;
      padding: 20px;
      overflow: hidden;
      img{
        display: block;
        float: left;
        width: 60px;
        height: 60px;
      }
      .content{
        float: left;
        width: 980px;
        margin-left: 20px;
        li{
          font-size: 16px;
          font-weight: 400;
          color: #5C5C5C;
          line-height: 22px;
          height: 34px;
          span{
            margin-right: 10px;
          }
        }
      }
    }
    .showMore{
      text-align: center;
      font-size: 16px;
      font-weight: 400;
      color: #ABABAB;
      line-height: 22px;
      cursor: pointer;
      margin-top: 30px;
      img{
        position: relative;
        top:3px;
        margin-right: 2px;
      }
    }
  }
}
</style>